// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1DQrg","block":"style_block__r8evg","icon":"style_icon__3Ru0q"};